let jQuery = require("jquery");

// Bootstrap JS
let bootstrap = require('bootstrap');

require("slick-carousel");

;(function ($) {

    /**
     * Find which side of an element the mouse has entered from
     * @param mouse
     * @param elem
     * @returns {string}
     */
    let mouseIntersectingFromEdge = function (obj, event ) {
        let directionName = null;

        let w = obj.offsetWidth,
            h = obj.offsetHeight,
            x = (event.pageX - obj.offsetLeft - (w / 2) * (w > h ? (h / w) : 1)),
            y = (event.pageY - obj.offsetTop - (h / 2) * (h > w ? (w / h) : 1)),
            direction = Math.round( Math.atan2(y, x) / 1.57079633 + 5 ) % 4;

        if (direction == 0) {
            directionName = 'top';
        } else if (direction == 1) {
            directionName = 'right';
        } else if (direction == 2) {
            directionName = 'bottom';
        } else if (direction == 3) {
            directionName = 'left';
        }
        return directionName;
    }

    /**
     * Add some utility classes to the body...
     */
    const sacouk_body_utility_classes = function () {
        try {
            document.body.classList.add('js');
            document.getElementsByTagName('body')[0].className += ' ' + (/(Firefox|MSIE|Chrome|Safari|Opera)[\/\s](\d+)/).exec(navigator.userAgent).splice(1, 2).join(' v-').toLowerCase();
            if( matchMedia('(hover: none)').matches ) {
                document.body.classList.add('touch');
            }else{
                document.body.classList.add('no-touch');
            }
        } catch (e) {

        }
    }
    sacouk_body_utility_classes();

    const animateCSSInitialiseCallback = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                let element = entry.target;
                let animationName = element.dataset.animations;
                if (animationName.length > 0) {
                    let updateInlineStyle = false;
                    let newInlineStyle = "";
                    if (element.hasAttribute('style')) {
                        newInlineStyle = element.getAttribute('style');
                    }
                    //Set the animation delay inline...
                    let animationDelay = element.dataset.delay;
                    if (animationDelay) {
                        newInlineStyle = newInlineStyle + ';animation-delay: ' + animationDelay;
                        updateInlineStyle = true;
                    }

                    let animationDuration = element.dataset.duration;
                    if (animationDuration) {
                        newInlineStyle = newInlineStyle + ';animation-duration: ' + animationDuration;
                        updateInlineStyle = true;
                    }

                    if (updateInlineStyle) {
                        element.setAttribute('style', newInlineStyle);
                    }

                    let animationClasses = animationName.split(" ");
                    element.classList.add("animate__animated");
                    animationClasses.forEach(animationClass => {
                        element.classList.add("animate__" + animationClass);
                    });
                    element.classList.remove("animate");
                }

                // stop observing this element
                observer.unobserve(entry.target);
            }
        });
    };

    const options = {
        //root: document.getElementById('app' ),
        root: null,
        rootMargin: '-75px',
        threshold: 0
    };
    const animateCSSInitialiseObserver = new IntersectionObserver(animateCSSInitialiseCallback, options);

    $(document).ready(function () {

        //Setup the animated elements
        const animatedElements = document.querySelectorAll('.animate');
        animatedElements.forEach(animatedElement => {
            animateCSSInitialiseObserver.observe(animatedElement);
        });

        let menuToggle = $('.menu-toggle');
        let mainMenu = $('.main-navigation');
        menuToggle.on('click', function(){
            menuToggle.toggleClass('open');
            mainMenu.toggleClass('open');
        });

        let animationGridClasses = ['animate-top-in', 'animate-left-in', 'animate-bottom-in', 'animate-right-in', 'animate-top-out', 'animate-left-out', 'animate-bottom-out', 'animate-right-out'];

        let caseStudyGridItems = $('.grid-animated-item');
        caseStudyGridItems.on('mouseenter', function( event ){
            let direction = mouseIntersectingFromEdge(this, event );
            $(this).removeClass( animationGridClasses.join(' ') );
            $(this).addClass('animate-grid').addClass(`animate-${direction}-in`);

        })
        caseStudyGridItems.on('mouseleave', function( event ){
            let direction = mouseIntersectingFromEdge(this, event );
            let animationClassName = `animate-${direction}-out`;
            $(this).addClass( animationClassName );
            let animationClassesToRemove = animationGridClasses.filter( className => animationClassName != className ).join(' ');
            $(this).removeClass( animationClassesToRemove );
        });

        $('.heroes').slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            adaptiveHeight: false,
            dots: true,
            arrows: false
        });

        $('.carousel').slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 750,
            adaptiveHeight: true,
            dots: false,
            arrows: false,
            slidesToShow: 6,
            slidesToScroll: 1,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        infinite: true
                    }
                },{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                }, {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                    }
                }
            ]
        });

        //Terms & Conditions form
        let tcForm = $('#form-terms');
        if( tcForm.length > 0 ){
            tcForm.submit(function (event) {
                event.preventDefault();

                let formData = {
                    name: $("#name").val(),
                    email: $("#email").val(),
                    organisation: $("#organisation").val(),
                    project: $("#project").val(),
                    date: $("#date").val(),
                    terms: $("#terms").val(),
                    terms: ($("#terms").is(':checked') ) ? "Agreed" : ""  ,
                    submit: 'ajax-submit',
                };

                $.ajax({
                    type: "POST",
                    url: "/app/terms.php",
                    data: formData,
                    dataType: "json",
                    encode: true,
                }).done(function (data) {
                    console.log('data',data);
                    console.log('data.response',data.result);
                    if( 1 === parseInt( data.result ) ){
                        $("#tp-form-container").addClass('d-none');
                        tcForm.addClass('d-none');
                        $("#tp-form-success").removeClass('d-none');
                    }
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    tcForm.addClass('was-validated');
                    let errors = jqXHR.responseJSON.errors;
                    for (const key in errors) {
                        let eleId = "#" + key + "-error";
                        console.log( "eleID" + eleId );
                        let ele = $(eleId);
                        if( ele.length > 0 ){
                            console.log( "Message" + errors[key] );
                            ele.html( errors[key] );
                            ele.removeClass('d-none').addClass('d-block');
                        }
                    }
                });

            });
        }

    });

})(jQuery);
